import {IConsumeService} from '../../../domain/interfaces/IConsumeService';
import {IExtract} from '../../../domain/models/Extract';

const GetExtractUseCase = (consumeApi: IConsumeService, localId: string, orderPadId: string): Promise<IExtract> => {
  const response = consumeApi.getExtract(localId, orderPadId);
  return response;
};
export default GetExtractUseCase;
